<template>
  <div class="dropdown">
    <div
      class="dropdown__toggle"
      aria-haspopup="true"
      :aria-expanded="isOpen"
      @click.prevent="isOpen = !isOpen"
    >
      <slot name="trigger"></slot>
    </div>

    <div v-show="isOpen" class="dropdown__menu" :class="classes" :style="{ width }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",

  props: {
    width: { default: "auto" },
    classes: { default: "right-0" }
  },

  data() {
    return {
      isOpen: false
    }
  },

  watch: {
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeIfClickedOutside)
      }
    }
  },

  methods: {
    closeIfClickedOutside(event) {
      if (!event.target.closest(".dropdown")) {
        this.isOpen = false
        document.removeEventListener("click", this.closeIfClickedOutside)
      }
    }
  }
}
</script>

<style>
.dropdown {
  position: relative;
}

.dropdown__menu {
  position: absolute;
  z-index: 100;
  bottom: 6rem;
}

.dropdown__menu::after {
  content: "";
  top: 100%;
  right: 10%;
  border: solid transparent;
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-top-color: #fff5e4;
  border-width: 9px;
  margin-left: -9px;
}
</style>
